module.exports = __webpack_public_path__ + "img/info.033d00c8.svg";